import React from 'react';

import { ReactComponent as Logo } from '../../assets/images/logo/logo-light.svg';
import { ReactComponent as DarkLogo } from '../../assets/images/logo/logo-blue.svg';

import './style.scss';

const Header = ({ blue = false, introTitle }) => {

  return (
    <header className="Header">
      <div className="Header__logo">
        <a href="https://www.nbbu.nl/">
          {!blue ? <Logo /> : <DarkLogo /> }
        </a>
      </div>
      <div className="Header__title">{introTitle}</div>
    </header>
  );
};

export default Header;
